mobileSize = 800;


$(document).ready(function(){
  // Check Window Size
  const windowSize = $(window).width();

  /// Email Signup

  const $emailSignup = $('.footer .emailSignup');
  $emailSignup.find('.emailSubmitButton').text('Subscribe');
  $emailSignup.find('.inputFieldTextbox').val('');
  $emailSignup.find('.inputFieldTextbox').attr('placeholder', 'Email Address');
  $emailSignup.find('.emailSignupText').html("Sign up for Fayette County Fair's Exciting Deals & Updates");

  if (windowSize < 800) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 801) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Description
  $('#swiperWidget .swiper-content-container').appendTo($('.tier-one'));

  /// Footer logo replace

  $('.footer .saffire_logo').attr('src', FULLCLIENTTHEMEPATH + 'images/saffire-logo.png');

  /// Down Arrow
  
  $(".down-arrow").click(function (){
    $('html, body').animate({
        scrollTop: $(".tier-two").offset().top
    }, 1000);
  });

});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');
});